<template>
  <section class="task-wrap" :style="dBHeight">
    <modals-container @updateBatch="getBatchList"></modals-container>
    <div class="tab_ty1">
      <AuditTab :currentTab="3" />
      <div class="tab-content">
        <div>
          <div class="tab_ty2">
            <AuditSubTab :currentTab="3" :currentTab2="5" />
            <div class="tab-content">
              <div>
                <div class="tb-list_ty1 audit003">
                  <div class="tb-header clear">
                    <div class="tb_num fl">
                      <div class="num" v-html="$i18nUtil.trans('search.000','총 {cnt}건',{cnt:totalCount})">
                      </div>
                    </div>
                    <div class="btnDiv fr">
                      <button
                        type="button"
                        class="btn-primary-small"
                        @click="batchRegist"
                      >배치 등록
                      </button>
                    </div>
                      <div class="search_ty2" style="float: right;padding-right: 20px;">
                        <input
                          type="text"
                          required
                          placeholder="배치 검색"
                          v-model="searchKeyword"
                          @keyup.enter="[changePage(), getBatchList()]"
                        />
                        <button
                          type="button"
                          class="input-txt"
                          @click="[changePage(), getBatchList()]"
                        >
                        {{$i18nUtil.trans("search.039","검색")}}
                        </button>
                      </div>
                  </div>

                  <v-data-table
                    v-model="selected"
                    :headers="headers"
                    :items="batchList"
                    hide-default-footer
                    class="tb-contents"
                  >
                    <template v-slot:item="{ item }">
                      <tr>
                        <td>
                          <div>
                            <span>
                              {{ item.scheduleType }}<br />({{item.scheduleTitle}})
                            </span>
                          </div>
                        </td>
                        <td>
                          <div>
                            <span>
                              <button
                                type="button"
                                class="btn-primary-small"
                                style="padding: 0 8px;"
                                @click="toggleExecuteBatch(item)"
                              >
                                {{ item.executeYn === true ? '실행' : '미실행' }}
                              </button>
                             </span>
                          </div>
                        </td>
                        <td>
                          <div>
                            <span>{{ item.triggerState }}</span>
                          </div>
                        </td>
                        <td>
                          <div>
                            <span>{{ item.cronExpression }}</span>
                          </div>
                        </td>
                        <td>
                          <div>
                            <span>{{ item.diffTime }}</span>
                          </div>
                        </td>
                        <td>
                          <div>
                            <span>{{ item.lastRunDate }}</span>
                          </div>
                        </td>
                        <td>
                          <div>
                            <span>{{ item.lastRunResult === true ? '성공' : '실패' }}</span>
                          </div>
                        </td>
                        <td>
                          <div>
                            <span>{{ item.nextFireTime }}</span>
                          </div>
                        </td>
                        <td>
                          <div>
                            <span>
                              <button type="button" class="btn-primary-small" style="padding: 0 8px;" @click="showBatchDetail(item)">상세</button>
                            </span>
                          </div>
                        </td>
                      </tr>
                    </template>

                    <template slot="no-data">
                      <div class="nodata-txt-noicon">
                        <v-alert :value="true">
                          배치 리스트가 없습니다.
                        </v-alert>
                      </div>
                    </template>
                  </v-data-table>

                  <div v-show="pageCount > 0" class="pagination">
                    <v-pagination
                      v-model="page"
                      circle
                      :length="pageCount"
                      :total-visible="7"
                      @input="getBatchList"
                    ></v-pagination>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapActions } from "vuex";
import AuditSubTab from "./AuditSubTab";
import AuditTab from "./AuditTab";
import BatchDialog from "./modal/BatchDialog";
import BatchRegist from "./modal/BatchRegist";

export default {
  components: {
    AuditSubTab,
    AuditTab,
    BatchDialog,
    BatchRegist,
  },
  data() {
    return {
      dBHeight: {
        "min-height": window.innerHeight - 151 + "px",
      },
      enabled: true,
      show: false,
      page: 1,
      pageCount: 0,
      totalCount: 0,
      itemsPerPage: 10,
      singleSelect: false,
      selected: [],
      headers: [
        { text: "타입", sortable: false, value: "scheduleType", custom: true },
        { text: "실행", align: "center", sortable: false, value: "executeYn", custom: true },
        { text: "상태", align: "center", sortable: false, value: "triggerState" },
        { text: "CRON", sortable: false, value: "cronExpression" },
        { text: "실행간격", align: "center", sortable: false, value: "diffTime" },
        { text: "최종실행", align: "center", sortable: false, value: "lastRunDate" },
        { text: "최종실행결과", align: "center", sortable: false, value: "lastRunResult", custom: true },
        { text: "다음실행", align: "center", sortable: false, value: "nextFireTime" },
        { text: "변경/삭제", align: "center", sortable: false, value: "actions" }
      ],
      toastInfo: {
        obj: this.$toasted,
        message: "",
        options: {
          theme: "toasted-primary",
          position: "bottom-left",
          duration: 3000,
        },
      },
      batchList: [],
      searchKeyword: '',
      doFetch: 0,
    };
  },
  created() {
    this.getBatchList();
  },
  methods: {
    /* 공통 AXIOS 호출하여 통신 (restAction.js) */
    ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION"]),
    ...mapActions("modals", ["showModal", "showToast"]),
    /* 배치 리스트 조회 */
    getBatchList() {
      let obj = this;

      let reqData = {};
      reqData.params = {
        searchKeyword: obj.searchKeyword,
        currentPage: obj.page,
        itemsPerPage: obj.itemsPerPage,
      };
      reqData.url = "/api/batch/list";
      reqData.method = "post";
      
      //프로그레스바 시작
      this.showLoadingbar();
      obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then((res) => {
          //프로그레스바 종료
          this.hideLoadingbar();
          if (res.errorCode == null) {
            obj.batchList = res.result.batchList;
            obj.totalCount = res.result.batchCount;
            obj.pageCount = res.result.batchPageCount;
          }
        })
        .catch((err) => {
          console.log("axios err => ", err);
        });
    },
    // 실행 & 미실행 버튼 동작
    toggleExecuteBatch(batch) {
      let obj = this;

      let reqData = {};
      reqData.params = {
        scheduleType: batch.scheduleType,
        tenantId: "DEFAULT",        
      };
      reqData.url = "/api/batch/toggleExecuteBatch";
      reqData.method = "post";
      
      //프로그레스바 시작
      this.showLoadingbar();
      obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then((res) => {
          //프로그레스바 종료
          this.hideLoadingbar();
           if (res.errorCode == null) {
            if (res.result.success) {
              obj.doFetch = obj.doFetch + 1
            } else {
              obj.toastInfo.message = res.errorCode;
              obj.showToast(obj.toastInfo);
            }
            obj.getBatchList();
          }
          return false
        })
        .catch((err) => {
          console.log("axios err => ", err);
        });
    },
    showBatchDetail(batch) {
      const modalInfo = {
          obj: this.$modal,
          component: BatchDialog,
          target : batch,
          width: "650px",
          height: "720px",
      };
      this.showModal(modalInfo);
    },
    batchRegist() {
      const modalInfo = {
          obj: this.$modal,
          component: BatchRegist,
          width: "650px",
          height: "450px",
      };
      this.showModal(modalInfo);
    },
    changePage() {
      this.page = 1;
    },
  },
};
</script>

<style scoped>
.audit003 {
  margin-top: 38px;
}
.audit003 >>> ::before,
.audit003 >>> ::after {
  background: none;
  visibility: hidden;
}
.audit003 >>> th:nth-child(1),
.audit003 >>> td:nth-child(1) {
  text-align: left;
  width: calc(100% - 70px - 75px - 200px - 80px - 150px - 75px - 150px - 65px) !important;
  word-break: break-all;
}
.audit003 >>> th:nth-child(2),
.audit003 >>> td:nth-child(2) {
  text-align: center;
  width: 70px !important;
}
.audit003 >>> th:nth-child(3),
.audit003 >>> td:nth-child(3) {
  text-align: center;
  width: 75px !important;
}
.audit003 >>> th:nth-child(4),
.audit003 >>> td:nth-child(4) {
  text-align: left;
  width: 200px !important;
  word-break: break-all;
}
.audit003 >>> th:nth-child(5),
.audit003 >>> td:nth-child(5) {
  text-align: center;
  width: 80px !important;
}
.audit003 >>> th:nth-child(6),
.audit003 >>> td:nth-child(6) {
  text-align: center;
  width: 150px !important;
}
.audit003 >>> th:nth-child(7),
.audit003 >>> td:nth-child(7) {
  text-align: center;
  width: 75px !important;
}
.audit003 >>> th:nth-child(8),
.audit003 >>> td:nth-child(8) {
  text-align: center;
  width: 150px !important;
}
.audit003 >>> th:nth-child(9),
.audit003 >>> td:nth-child(9) {
  text-align: center;
  width: 65px !important;  
}
.audit003 >>> input {
  background-color: transparent;
}
.audit003 >>> th:nth-child(1) > span {
  margin-left: 123px;
}
.audit003 >>> th:nth-child(4) > span {
  margin-left: 82px;
}
.audit003 >>> td:nth-child(4) > div > span {
  margin-left: 10px;  
}
.audit003 >>> td:nth-child(6) > div > span {
  margin-left: 3px;  
}
.audit003 >>> td:nth-child(8) > div > span {
  margin-left: 3px;  
}
.audit003 >>> td:nth-child(1) > div {
  padding-left: 13px;
}
.audit003 >>> td:nth-child(3) > div {
  padding-left: 5px;
}
</style>


// WEBPACK FOOTER //
// src/components/cowork/cosys/audit/base/tab/history/BatchList.vue